export default {"src":"/_next/static/media/green_tick_icon.75a5a383.svg","height":27,"width":28,"blurWidth":0,"blurHeight":0};